<template>
    <div id="terms-popup">
        <div class="modal" id="popup">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="popup-header modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="WordSection1">
                            <p
                                class="MsoNormal"
                                align="center"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: center; line-height: normal; background: white">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >WillYou.net - Terms of Service for Jewelers</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Last updated: September 7, 2019</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >This agreement between Willyou.net (“<b><i>we</i></b
                                    >”, “<b><i>us</i></b
                                    >”, “<b><i>our</i></b
                                    >” or “<b><i>Company</i></b
                                    >”), and you, a jeweler subscribing to our service (“<b><i>you</i></b
                                    >” or “<b><i>your</i></b
                                    >”) consists of (a) these Terms of Service, (b) our privacy policy and cookie policy and (c) the Order (as defined below),
                                    if applicable (collectively, this “<b><i>Agreement</i></b
                                    >”). This Agreement governs your use of the Platform (as defined below), or any other technology or services offered to you
                                    by us that are not covered by other specific agreements, in connection with our proprietary Platform (the “<b
                                        ><i>Service</i></b
                                    >”).</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >BY EXECUTING AN ORDER OR OTHERWISE CLICKING A BOX INDICATING YOUR ACCEPTANCE OF THIS AGREEMENT, YOU EXPRESSLY ACKNOWLEDGE
                                    AND AGREE THAT YOU HAVE READ THIS AGREEMENT AND ARE BOUND BY THIS AGREEMENT, AND YOU HEREBY AGREE TO THE TERMS OF THIS
                                    AGREEMENT. IF YOU ARE AN INDIVIDUAL ENTERING INTO THIS AGREEMENT ON BEHALF OF A LEGAL ENTITY, YOU HEREBY REPRESENT AND
                                    WARRANT TO US THAT YOU ARE AUTHORIZED TO ENTER INTO THIS AGREEMENT ON BEHALF OF SUCH ENTITY AND BIND SUCH ENTITY TO THE
                                    TERMS AND CONDITIONS CONTAINED IN THIS AGREEMENT, IN WHICH CASE, THE TERMS “YOU” AND “YOUR” WILL REFER TO SUCH ENTITY. IF
                                    YOU DO NOT ACCEPT ALL THE TERMS AND CONDITIONS IN THIS AGREEMENT OR ARE NOT AN AUTHORIZED AGENT FOR THE LEGAL ENTITY THAT
                                    WISHES TO ENTER INTO THIS AGREEMENT, DO NOT EXECUTE AN ORDER OR OTHERWISE USE THE PLATFORM. YOU MAY NOT ENTER INTO THIS
                                    AGREEMENT OR OTHERWISE USE THE SERVICE OR THE PLATFORM IF YOU ARE A COMPETITOR TO THE COMPANY.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You may gain access to the Platform by (a) executing an Order or (b) by registering online on the WillYou.net Website,
                                    which includes and requires clicking a box indicating your acceptance of this Agreement.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >1.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Definitions.</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Aggregated Data</i></b
                                    >” means aggregated data and insights derived from Your Data or your access or use of the Platform, which do not identify
                                    you and cannot with reasonable means be attributed or traced back to Your Data.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Dashboard</i></b
                                    >” means the Company’s WillYou.net dashboard offered to Jewelers who have registered for the Service, consisting of a
                                    web-based interface, made available as a service via the Internet, through which registered Jewelers may access and use the
                                    functionality and features of the Service.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Feedback</i></b
                                    >” means information, suggestions or feedback concerning the Service or the Platform that you provide to the Company.</span
                                >
                            </p>

                            <p class="MsoListParagraphCxSpMiddle">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<a name="_Hlk18774296"></a
                                    ><a name="_Hlk18687334"
                                        ><span style="mso-bookmark: _Hlk18774296"><b>GIA Retailer Lookup Program</b></span></a
                                    ><span style="mso-bookmark: _Hlk18774296">” </span>means a program offered by Gemological Institute of America, which allows
                                    jewelers to list their retail establishments on jewelers information index, subject to the program’s terms of use: </span
                                ><span style="color: black; mso-color-alt: windowtext"
                                    ><a href="https://www.gia.edu/retailer-lookup-terms-of-use"
                                        ><span
                                            style="
                                                font-family: 'Times New Roman', serif;
                                                mso-ascii-theme-font: major-bidi;
                                                mso-fareast-font-family: 'Times New Roman';
                                                mso-hansi-theme-font: major-bidi;
                                                mso-bidi-theme-font: major-bidi;
                                            "
                                            >https://www.gia.edu/retailer-lookup-terms-of-use</span
                                        ></a
                                    ></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >.
                                </span>
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >e.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Order</i></b
                                    >” means a written ordering document executed by an authorized representative of each of you and the Company that
                                    incorporates these Terms of Service by reference. The Order will specify the Platform to which you are receiving access,
                                    fees related thereto, if any, and the duration of the Term.</span
                                >
                            </p>

                            <p class="MsoListParagraphCxSpMiddle">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >f.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Platform</i></b
                                    >” means the Dashboard and the Website.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >g.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Term</i></b
                                    >” means the Initial Term (as defined below) plus any Renewal Term(s) (as defined below).</span
                                >
                            </p>

                            <p class="MsoListParagraphCxSpMiddle">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >h.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Website</i></b
                                    >” means the WillYou.net website which allows users to choose rings and diamonds and connect with jewelers.
                                </span>
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >“<b><i>Your Data</i></b
                                    >” means data, content or other information provided by you to the Company (via the Dashboard or otherwise), excluding
                                    Feedback.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >2.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Interpretation.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >As used herein, the term “including”, means including, but not limited to, and without limitation, to the generality of the
                                    preceding phrase. All examples in this Agreement and all “i.e.” and “such as” notations, indicate an illustration, by way of
                                    example only, of the preceding phrase, without limiting its generality.<b><span style="letter-spacing: 0.3pt"></span></b
                                ></span>
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >3.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Access to Platform; Service Offering</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        >Evaluation</span
                                    ></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >. If you access the Service on an evaluation or beta basis via the Dashboard (the “<b><i>Evaluation Service</i></b
                                    >”), then you may use the Evaluation Service only for evaluation purposes and for a period of thirty (30) days beginning on
                                    the date the Company provides you with login credentials, unless otherwise set forth in the Order (the “<b
                                        ><i>Evaluation Period</i></b
                                    >”). Notwithstanding any other provision of this Agreement, the Company provides the Evaluation Service, and access to the
                                    Platform in connection therewith, (i) free of charge and without support and (ii) “AS IS” without indemnification or
                                    warranty of any kind. The Company does not provide any support with respect to the Evaluation Service. Also, certain
                                    features or services may not be available for the Evaluation Service. Continued use of the Platform after the Evaluation
                                    Period requires that you (A) execute an Order and (B) submit the applicable payment, if payment is required for the selected
                                    Service. Upon expiration of the Evaluation Period, you will not have access to the Evaluation Service.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        >SaaS Subscription</span
                                    ></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >. If you execute an Order that indicates you will receive access to the Dashboard and your details will be listed on the
                                    Website, subject to the terms and conditions of this Agreement, the Company hereby grants to you a nonexclusive,
                                    <span class="SpellE">nonsublicensable</span>, nontransferable right, during the Term, to access and use the Dashboard
                                    strictly for your internal business purposes and have your details listed on the Website.</span
                                >
                            </p>

                            <p class="MsoListParagraphCxSpMiddle">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        >Service Offering</span
                                    ></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >. Once you subscribe to the Service, we may display your business information on our Website and allow our Website users to
                                    provide you with their information and ring and diamond selections. Once you receive a user’s information, you will be
                                    responsible for evaluating the user and deciding whether or not to contact the user for the purpose of setting up an
                                    appointment with the user. You are solely responsible for all of your interactions with the users and you shall follow all
                                    applicable laws in your evaluation of and communications with a user. If you and a user agree to arrange for a user’s visit
                                    to your store location, the Company will contact a third-party distributor with the diamond information in order for the
                                    distributor contact you and to ship the diamond the user selected to your store. The shipment of the diamond to your store
                                    will be in the distributor’s sole discretion and any such arrangement shall be subject to any agreement between you and the
                                    distributor and/or terms and conditions imposed by the distributor.<span style="mso-spacerun: yes">  </span></span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >4.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Registration and user account</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You must be registered in order to use the Service. In order to apply for registration, you must complete our online
                                    application form, or a paper form that we may agree to provide to you, in which we indicate the mandatory fields for
                                    completion. If you do not provide the required information in these fields, you will not be able to register. You must
                                    provide true, accurate and complete information.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Login to the Dashboard is authenticated with a password, which you should periodically change. You must maintain the
                                    confidentiality of your account login details for your general account and for the Dashboard.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You are solely responsible for the security of your and your users’ login credentials and will not provide such login
                                    credentials to any third party. You are responsible for any use that occurs under your or your users’ login credentials. If
                                    you believe an unauthorized person has gained access to your or your users’ login credentials, you will notify us as soon as
                                    possible. You will ensure that your users comply with all terms and conditions of this Agreement and you remain responsible
                                    and liable for the acts and omissions of your users. If you become aware of any violation by any of your users, you will
                                    immediately terminate such user’s access to the Service.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >5.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Data</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >As between you and the Company, you retain all right, title, and interest in Your Data, except for the limited license
                                    expressly granted by you to the Company in this Section. You hereby grant to the Company a nonexclusive, royalty-free, fully
                                    paid up right and license, during the Term, to copy, display, distribute, modify and otherwise use Your Data, solely as
                                    necessary to provide the Service to you, including, but not limited to displaying Your Data on the Website and providing
                                    Your Data to the GIA Retailer Lookup Program and other similar websites and programs. You further acknowledge that the
                                    Company may create, collect, use and distribute Aggregated Data for our business purposes, including in connection with
                                    improving our products and services.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You acknowledge and agree that we will process, handle and use personally identifiable information (also known as “<b
                                        ><i>personal data</i></b
                                    >”) in accordance with our Privacy Policy located at </span
                                ><span style="color: black; mso-color-alt: windowtext"
                                    ><a href="https://willyou.net/privacy-policy"
                                        ><span
                                            style="
                                                font-family: 'Times New Roman', serif;
                                                mso-ascii-theme-font: major-bidi;
                                                mso-fareast-font-family: 'Times New Roman';
                                                mso-hansi-theme-font: major-bidi;
                                                mso-bidi-theme-font: major-bidi;
                                            "
                                            >https://willyou.net/privacy-policy</span
                                        ></a
                                    ></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    ">
                                    (the “<b><i>Privacy Policy</i></b
                                    >”).</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >In addition, to the extent you provide any Feedback to the Company, you hereby grant to the Company a nonexclusive,
                                    perpetual, irrevocable, royalty-free, sublicensable, transferable license to copy, display, distribute, perform, modify and
                                    otherwise use such Feedback or subject matter thereof in any way and without limitation.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We may delete Your Data from the Service, upon termination of this Agreement. You are responsible for maintaining back-up
                                    copies of Your Data. The Service does not provide, and is not intended to be, a data back-up service.</span
                                >
                            </p>

                            <p class="MsoListParagraphCxSpMiddle" style="margin-bottom: 0in; margin-bottom: 0.0001pt; mso-add-space: auto; line-height: normal">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >6.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Confidentiality.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >As used in this Agreement, “<b><i>Confidential Information</i></b
                                    >” means, subject to the exceptions set forth in the following sentence, any information or data, regardless of whether it
                                    is in tangible form, disclosed by either you or the Company (the “<b><i>Disclosing Party</i></b
                                    >”) that the Disclosing Party has either marked as confidential or proprietary, or has identified in writing as confidential
                                    or proprietary within thirty (30) days of disclosure to the other party (the “<b><i>Receiving Party</i></b
                                    >”); provided, however, that a Disclosing Party’s business plans, strategies, technology, research and development, current
                                    and prospective customers, billing records, and products or services will be deemed Confidential Information of the
                                    Disclosing Party even if not so marked or identified. The Company’s Confidential Information includes, without limitation,
                                    the Service, the Platform, the terms and conditions of this Agreement and any information related to any of the foregoing.
                                    Your Confidential Information includes Your Data, excluding Aggregated Data derived therefrom and Your Data which will be
                                    published on the Website. Information will not be deemed Confidential Information if such information: (a) is known to the
                                    Receiving Party prior to receipt from the Disclosing Party directly or indirectly from a source other than one having an
                                    obligation of confidentiality to the Disclosing Party; (b) becomes known (independently of disclosure by the Disclosing
                                    Party) to the Receiving Party directly or indirectly from a source other than one having an obligation of confidentiality to
                                    the Disclosing Party; (c) becomes publicly known or otherwise ceases to be secret or confidential, except through a breach
                                    of this Agreement by the Receiving Party; or (d) is developed independently by the Receiving Party without use of any
                                    Confidential Information of the Disclosing Party. Each party agrees that it will use the Confidential Information of the
                                    other party solely to perform its obligations or exercise its rights under this Agreement. Neither you nor the Company will
                                    disclose, or permit to be disclosed, the other party’s Confidential Information directly or indirectly, to any third party
                                    without the other party’s prior written consent. Both you and the Company will use commercially reasonable measures to
                                    protect the confidentiality and value of the other party’s Confidential Information. Notwithstanding any provision of this
                                    Agreement, either party may disclose the other party’s Confidential Information, in whole or in part: (i) to its employees,
                                    officers, directors, consultants and professional advisers (e.g., attorneys, auditors, financial advisors, accountants and
                                    other professional representatives) who have a need to know and are legally bound to keep such Confidential Information
                                    confidential by confidentiality obligations or, in the case of professional advisors, are bound by ethical duties to keep
                                    such Confidential Information confidential consistent with the terms of this Agreement; and (ii) as required by law (in
                                    which case each party will provide the other with prior written notification thereof, will provide such party with the
                                    opportunity to contest such disclosure, and will use its reasonable efforts to minimize such disclosure to the extent
                                    permitted by applicable law). Both you and the Company agree to exercise due care in protecting the Confidential Information
                                    of the other party from unauthorized use and disclosure. In the event of actual or threatened breach of the provisions of
                                    this Section, the non-breaching party will be entitled to seek immediate injunctive and other equitable relief, without
                                    waiving any other rights or remedies available to it. Both you and the Company will promptly notify the other in writing if
                                    it becomes aware of any violations of the confidentiality obligations set forth in this Agreement.<b
                                        ><span style="letter-spacing: 0.3pt"></span></b
                                ></span>
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >7.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Fees</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >In consideration of the provision of the Service to you, we may charge you a subscription fee in the future, and you will
                                    pay us the fees set forth in the Order in accordance with the terms and conditions of this Agreement.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><br />
                                    Before charging any initial fee or any other fee, you will be notified and have the option to be delisted from willyou.net
                                    with no charge.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >If any fees are due based on your Order, said fees will be quoted in U.S. Dollars and will be paid by you in U.S. Dollars,
                                    unless expressly stated otherwise. Fees are payable by wire transfer, check or major credit cards. We may, from time to
                                    time, and without specific notice to you, add additional payment methods to the then-current payment methods, or cease to
                                    use previously supported payment methods. You represent and warrant that you are lawfully permitted to use the selected
                                    payment method in connection with the Service. We may require additional information from you before completing payment
                                    transactions.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You must keep the billing information you provide to us current, complete, and accurate, and notify us promptly in case of
                                    any change in your billing information. By providing any credit card, online account or bank information, you authorize the
                                    Company to automatically charge or debit the selected payment method for the full amount due on a recurring basis (if
                                    applicable) until you notify the Company in writing with an alternative, authorized payment method. You will ensure that you
                                    have sufficient funds or credit (as applicable) associated with the selected method of payment. You understand that the
                                    amounts charged or debited may vary and that this authorization will remain in effect until the expiration or termination of
                                    this Agreement. If a payment is returned from a bank account for insufficient or uncollected funds or for erroneous
                                    information, the Company may reinitiate the returned debit to the applicable bank account. Any amounts owed to the Company
                                    that cannot be collected by debit may be charged to any backup credit card on file for you.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Unless otherwise set forth in the Order, the applicable subscription fees will be due and payable at the beginning of each
                                    subscription cycle set forth in the Order. All fees are exclusive of all sales, use, excise, value added, withholding and
                                    other taxes, and all customs duties and tariffs now or hereafter claimed or imposed by any governmental authority upon your
                                    use of the Service will be paid by you. The Company reserves the right to increase fees at any time, although increases in
                                    fees will not go into effect until the next renewal of the then-current term.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >e.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >All your payment obligations are non-cancelable and all amounts paid in connection with the Service are non-refundable,
                                    except as expressly set forth herein. You are responsible for paying all fees applicable to your subscription to the
                                    Service, whether or not you actively used, accessed or otherwise benefited from the Service.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >f.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Payment may be processed and handled through relevant third-party payment processors. Any payments processed through third
                                    party payment processors are therefore subject not only to this Agreement, but also the terms and conditions of the
                                    applicable third-party payment processor pursuant to your agreement with them. You acknowledge that such third-party payment
                                    processors may charge you commission. We are not responsible for such commission, which is strictly between you and the
                                    relevant payment processor.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >g.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Fees that we are unable to charge through the payment method you provided is deemed an overdue fee. Failure to settle any
                                    overdue fee within twenty (20) calendar days of its original due date will constitute a material breach of this Agreement
                                    and, without limiting any remedies available to the Company, the Company may: (i) terminate this Agreement; or (ii) suspend
                                    performance of or access to the Service, until payment is made current. Without derogating from any other rights and
                                    remedies available to us under applicable law, overdue fees will accrue interest at the lesser of the rate of one and one
                                    half percent (1.5%) per month or part thereof, cumulative monthly on the total amount due from the due date until the date
                                    of actual payment and the maximum rate permitted by applicable law. You will reimburse us for all legal costs and attorney’s
                                    fees we incur in the course of collecting your overdue fees.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >h.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We may modify, adapt, improve, or enhance the Service, or any of its features, user interface, design or any other aspect
                                    related to it, without being obligated to provide you notice thereof.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >8.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Restrictions</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You shall not modify, make derivative works of, disassemble, de-compile or reverse engineer any part of the Service or
                                    Platform, or otherwise attempt to discover its underlying code, structure, implementation or algorithms.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You shall not access or use the Service or Platform for any purpose other than as expressly permitted under this
                                    Agreement.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You shall not use the Service or Platform in order to develop, or create, or permit others to develop or create, a product
                                    or service similar or competitive to the Service or Platform.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You shall not offer the Service or Platform to third parties, including by reselling, licensing, renting, leasing,
                                    transferring, lending, timesharing, assigning or redistributing the Service, Platform or any part thereof.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >e.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You shall not perform or attempt to perform any of the following in connection with the Service or Platform:</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Breaching the security of the Service or Platform, or identifying, probing or scanning any security vulnerabilities in the
                                    Service or Platform;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >ii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Accessing data not intended for you, or accessing an account you are not authorized to access;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >iii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Interfering with, circumventing, manipulating, overloading, impairing or disrupting the operation, or the functionality of
                                    the Service or Platform;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >iv.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Working around any technical limitations in the Service or Platform;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >v.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Using any tool to enable features or functionalities that are otherwise disabled, inaccessible or undocumented in the
                                    Service or Platform;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >vi.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Collecting or processing information or data about the Company’s customers;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >vii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Sending any virus, worm, Trojan horse or other malicious or harmful code or attachment; or</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >viii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Using robots, crawlers, scrapers, and similar applications to scrape, harvest, collect or compile content from or through
                                    the Service or Platform.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >f.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You will only use the Service and Platform in compliance with all applicable laws, rules and regulations, and you represent
                                    and warrant that Your Data does not and will not violate any third-party rights or any applicable laws.
                                </span>
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >g.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You will not, and will not allow or assist third parties to, publish, distribute or disclose the results of any benchmark
                                    tests performed on the Platform or otherwise use any testing results related to the Platform for your marketing purposes, or
                                    for development of competing technology.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >h.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >YOU MAY NOT USE THE SERVICE OR PLATFORM FOR ANY ACTIVITY THAT CONSTITUTES, OR ENCOURAGES CONDUCT THAT WOULD CONSTITUTE, A
                                    CRIMINAL OFFENSE, GIVE RISE TO CIVIL LIABILITY OR OTHERWISE VIOLATE ANY APPLICABLE LAW.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >WE MAY EMPLOY MEASURES TO DETECT AND PREVENT FRAUDULENT OR ABUSIVE USE OF THE SERVICE, AS WELL AS MISUSE OF THE SERVICE AND
                                    PLATFORM. WE MAY SUSPEND OR TERMINATE YOUR ACCOUNT ON AND ACCESS TO THE SERVICE AND PLATFORM, WITHOUT PRIOR NOTICE, IF WE,
                                    IN OUR SOLE DISCRETION, BELIEVE THAT YOU HAVE ENGAGED IN FRAUDULENT OR ABUSIVE USE, OR MISUSE, OF THE SERVICE OR
                                    PLATFORM.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore"
                                            >9.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                        ></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Term and Termination</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >This Agreement commences upon execution of the Order or when you click a box agreeing to this Agreement, and, unless
                                    earlier terminated as set forth herein, continue in effect for the initial term set forth in the Order (or, if you are
                                    accessing an Evaluation Service only, as set forth in Section 3(a) above) (the “<b><i>Initial Term</i></b
                                    >”). Except for use of the Evaluation Service, unless otherwise set forth in the Order, this Agreement will automatically
                                    renew for additional periods of equal duration (each, a “<b><i>Renewal Term</i></b
                                    >”), unless either party gives notice of non-renewal at least thirty (30) days’ prior to the end of the then-current
                                    term.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Either party may terminate this Agreement upon written notice to the other party:</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >In the event of a breach of this Agreement by the other party, where the breach remains uncured for fifteen (15) days
                                    following written notice thereof from the non-breaching party to the breaching party, but if a breach is of a nature that
                                    cannot be cured, then the non-breaching party may terminate this Agreement immediately upon written notice to the other
                                    party;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >ii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >If the terminating party is required to do so by applicable law;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >iii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >If the other party becomes or is declared insolvent or bankrupt, is the subject of any proceeding related to its
                                    liquidation or insolvency (whether voluntary or involuntary) which, if involuntary, proceedings are not dismissed within
                                    sixty (60) days of their commencement, makes an assignment for the benefit of creditors, or takes or is subject to any such
                                    other comparable action in any relevant jurisdiction.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >In addition, the Company may terminate this Agreement immediately for convenience without prior written notice to you. If
                                    the Company exercises this right, the Company will refund to you any fees prepaid for the remainder of the then-current
                                    term.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Immediately upon expiration or termination of this Agreement:</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We may terminate your account on the Service and delete Your Data stored in our systems;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >ii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You must cease any and all use of the Service and Platform; and</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >iii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We will charge you for all then-outstanding fees (if any) incurred prior to the effective date of expiration or
                                    termination.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <ol style="margin-top: 0in" start="1" type="1">
                                <li
                                    class="MsoNormal"
                                    style="
                                        color: #404040;
                                        margin-bottom: 0in;
                                        margin-bottom: 0.0001pt;
                                        text-align: justify;
                                        line-height: normal;
                                        mso-list: l10 level1 lfo8;
                                        tab-stops: list 0.5in;
                                        background: white;
                                    ">
                                    <span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                        "
                                        >The following Sections will survive the expiration or termination of this Agreement: 1, 2, 5, 6, 7, 8, 9, 10, 12(a),
                                        12(b), 13, 14, 16, 18, and 19.</span
                                    >
                                </li>
                            </ol>

                            <p
                                class="MsoNormal"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 0.5in;
                                    margin-bottom: 0.0001pt;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore">10.<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Disclaimers and Limitation of Liability</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We do not guarantee that the Service and Platform will operate in an uninterrupted or error-free manner, or that it will
                                    always be available, free from errors, omissions or malfunctions.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >If we receive notice of any failure or malfunction, or if we otherwise become aware of any such failure or malfunction, we
                                    will attempt to regain the Service’s availability as soon as practicable. However, such incidents will not be considered a
                                    breach of this Agreement. Without limiting the foregoing, in no event will the Company be responsible for any slow-downs,
                                    failures or other malfunctions that are caused by your breach of this Agreement, including any usage limitations set forth
                                    in the Order.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You are solely and exclusively responsible: (i) for all actions you take in response to your usage of the Service and
                                    Platform; (ii) to check for any alerts or warnings issued by the Service and determine what actions are appropriate in light
                                    thereof; and (iii) to carry out such actions as you deem appropriate as a result of your usage of the Service and Platform.
                                    We are not responsible or liable for your reliance upon, or use of, the Service or Platform, your actions in connection with
                                    the Service or Platform, or any consequences resulting therefrom.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, EXCEPT FOR LIABILITY ARISING FROM A PARTY’S (I) GROSS NEGLIGENCE OR
                                    INTENTIONAL MISCONDUCT, (II) BREACH OF ITS CONFIDENTIALITY OBLIGATIONS HEREUNDER, (III) INDEMNIFICATION OBLIGATIONS
                                    HEREUNDER OR (IV) INFRINGEMENT OR MISAPPROPRIATION OF THE OTHER PARTY’S INTELLECTUAL PROPERTY RIGHTS, NEITHER YOU NOR THE
                                    COMPANY, INCLUDING THEIR RESPECTIVE EMPLOYEES, DIRECTORS, OFFICERS, SHAREHOLDERS, ADVISORS, AND ANYONE ACTING ON THEIR
                                    BEHALF, WILL BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, STATUTORY OR PUNITIVE DAMAGES, LOSSES
                                    (INCLUDING LOSS OF PROFIT, LOSS OF BUSINESS OR BUSINESS OPPORTUNITIES AND LOSS OF DATA), COSTS, EXPENSES AND PAYMENTS,
                                    EITHER IN TORT, CONTRACT, OR IN ANY OTHER FORM OR THEORY OF LIABILITY (INCLUDING NEGLIGENCE), ARISING FROM, OR IN
                                    CONNECTION, WITH THIS AGREEMENT, ANY USE OF, OR THE INABILITY TO USE THE SERVICE OR PLATFORM, ANY RELIANCE UPON THE SERVICE
                                    OR PLATFORM OR ANY ERROR, INCOMPLETENESS, INCORRECTNESS OR INACCURACY OF THE SERVICE OR PLATFORM.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >e.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW EXCEPT FOR LIABILITY ARISING FROM A PARTY’S (I) GROSS NEGLIGENCE OR
                                    INTENTIONAL MISCONDUCT, (II) BREACH OF ITS CONFIDENTIALITY OBLIGATIONS HEREUNDER, (III) INDEMNIFICATION OBLIGATIONS
                                    HEREUNDER OR (IV) INFRINGEMENT OR MISAPPROPRIATION OF THE OTHER PARTY’S INTELLECTUAL PROPERTY RIGHTS, THE TOTAL AND
                                    AGGREGATE LIABILITY OF EACH PARTY (INCLUDING THEIR RESPECTIVE EMPLOYEES, DIRECTORS, OFFICERS, SHAREHOLDERS, ADVISORS, AND
                                    ANYONE ACTING ON THEIR BEHALF), FOR DAMAGES ARISING OF OR RELATED TO THIS AGREEMENT, THE SERVICE AND THE PLATFORM, SHALL BE
                                    LIMITED TO THE TOTAL FEES PAYABLE BY YOU TO THE COMPANY IN THE TWELVE (12) MONTHS PRECEDING THE EVENT PURPORTEDLY GIVING
                                    RISE TO THE CLAIM.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >f.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >ALTHOUGH WE USE SKILL AND EFFORTS TO DEVELOP THE SERVICE AND HAVE THE SERVICE PROVIDE ACCURATE, RELIABLE, EFFECTIVE AND
                                    ACTIONABLE DATA, WE DO NOT GUARANTEE, MAKE NO REPRESENTATION, AND PROVIDE NO WARRANTY ABOUT THE RELIABILITY, EFFECTIVENESS,
                                    ACCURACY OR COMPLETENESS OF THE SERVICE OR PLATFORM, THE EXPECTED BUSINESS RESULTS, OUTCOMES OR ANY OTHER OPERATIONAL
                                    BENEFITS FROM UTILIZING THE SERVICE AND PLATFORM.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >g.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >THE SERVICE AND PLATFORM IS PROVIDED TO YOU “AS IS”. WE DISCLAIM ALL WARRANTIES AND REPRESENTATIONS, EITHER EXPRESS OR
                                    IMPLIED, WITH RESPECT TO THE SERVICE, INCLUDING ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                                    QUALITY, ACCURACY, NON-INFRINGEMENT, TITLE, SECURITY, COMPATIBILITY OR PERFORMANCE.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore">11.<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Support and Maintenance</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >During the Term, we, either directly or with the assistance of third parties, will use commercially reasonable efforts to
                                    provide you technical support for technical questions,&nbsp;problems&nbsp;and inquiries regarding the Service or Platform,
                                    during our business days and hours. We will also use commercially reasonable efforts to provide any additional support
                                    services set forth in the Order in accordance with the terms therein, to the extent applicable.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We will attempt to respond to your technical questions,&nbsp;problems and inquiries within a reasonable time. However,
                                    we:</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >May decline to provide such support for matters that we deem, at our sole discretion, to require unreasonable time, effort,
                                    costs or expenses;</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -1.5in;
                                    mso-text-indent-alt: -9pt;
                                    line-height: normal;
                                    mso-list: l3 level3 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        ><span style="font: 7pt 'Times New Roman'"
                                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
                                        >ii.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Make no warranties to any specific response-time or to the successful or satisfactory resolution of the question, problem
                                    or inquiry.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1.5in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >For the purpose of our provision of technical support for your technical questions,&nbsp;problems&nbsp;and inquiries, you
                                    will cooperate, and work closely with us, to reproduce malfunctions, including conducting diagnostic or troubleshooting
                                    activities, as we reasonably request.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >In the event you would like to engage the Company for services beyond the general support assistance described above, the
                                    Company may agree to provide such services for an additional fee. All such services, and the fees related thereto, shall be
                                    described in a subsequent writing and mutually agreed upon.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore">12.<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Intellectual Property</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >The Service and Platform are proprietary to the Company. The Platform is made available for use and&nbsp;access on a
                                    subscription basis and is not sold.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Except for your limited access to use the Platform according to this Agreement, this Agreement does not grant to you or
                                    assign to you, any right, title, or interest in or to the Service or Platform or any associated intellectual property
                                    rights. As between the parties, all rights, title and interest, including copyrights, patents, trademarks, trade names,
                                    trade secrets and other intellectual property rights, and any goodwill associated therewith, in and to the Service and
                                    Platform, or any part thereof, including computer code, graphic design, layout and the user interfaces, whether or not based
                                    on or resulting from Feedback, are and will remain at all times owned by the Company. You will not do, or cause to be done,
                                    any acts or things contesting or in any way impairing or tending to impair any portion of the right, title and interest of
                                    the Company in and to its intellectual property rights. You will not delete or in any manner alter the copyright, trademark,
                                    or other proprietary rights notices or markings that appear on the Platform as delivered or made available to you.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Unless you notify us otherwise in writing, we may identify you as a customer and user of the Service on our Website and in
                                    other online or offline marketing materials and press releases, including as part of the GIA Retailer Lookup Program, and we
                                    may publish case studies and other marketing materials related to your use of the Service. We acknowledge that your company
                                    name and logo are protected by intellectual property rights. You hereby grant to the Company a non-exclusive, royalty-free
                                    and fully paid up license, during the Term, to use your name, logo, and website URL, on our Website and in other online or
                                    offline marketing materials relating to the Service and to share the same with the GIA Retailer Lookup Program. We will use
                                    this content strictly in accordance with any usage guidelines you provide to us.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore">13.<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Indemnification</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You agree to indemnify and hold harmless us and our directors, officers, employees, and contractors, upon our request and
                                    at your own expense, from, and against, any damages, loss, costs, expenses and payments, including reasonable attorney’s
                                    fees and legal expenses, arising from any complaint, claim, plea, or demand brought by a third party (including any users of
                                    the Website who contact you to purchase or view a ring and/or a diamond) in connection with, arising from or otherwise
                                    related to (a) your breach of this Agreement or (b) your gross negligence or willful misconduct.</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >If we seek indemnification from you, we will provide you with (i) prompt written notice of any indemnifiable claim; (ii)
                                    reasonable assistance and cooperation in the defense of such indemnifiable claim and any related settlement negotiations, at
                                    your expense; and (iii) exclusive control over the defense or settlement of such indemnifiable claim, provided, however,
                                    that we may settle or reach compromise on any such claim without your consent, if and to the extent such settlement or
                                    compromise does not impose any liability (monetary, criminal or otherwise) on you. We will have the right to participate,
                                    our own expense, in the defense (and related settlement negotiations) of any indemnifiable claim with counsel of our own
                                    selection.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore">14.<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Governing Law and Venue; Arbitration</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >a.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Regardless of your place of residence and business or where you access or use the Service, this Agreement will be governed
                                    by and construed solely in accordance with the laws of the State of New York, excluding any otherwise applicable rules of
                                    conflict of laws, which would result in the application of the laws of a jurisdiction other than the State of New York.
                                </span>
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >b.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >ANY AND ALL DISPUTES, CLAIMS OR CONTROVERSIES BETWEEN YOU AND THE COMPANY REGARDING THIS AGREEMENT OR THE USE OF THE
                                    SERVICE, WHICH ARE NOT AMICABLY RESOLVED, SHALL BE SETTLED THROUGH BINDING ARBITRATION (RATHER THAN IN COURT), ADMINISTERED
                                    BY THE AMERICAN ARBITRATION ASSOCIATION (AAA) UNDER ITS COMMERCIAL ARBITRATION RULES.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-spacerun: yes"> </span></span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >c.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >JUDGMENT ON THE AWARD RENDERED BY THE ARBITRATOR(S) MAY BE ENTERED IN ANY COURT HAVING JURISDICTION THEREOF.
                                </span>
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >d.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >THE FEDERAL ARBITRATION ACT AND FEDERAL ARBITRATION LAW APPLY TO THESE TERMS.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >e.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >THERE IS NO JUDGE OR JURY IN ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED. HOWEVER, AN ARBITRATOR CAN
                                    AWARD ON AN INDIVIDUAL BASIS THE SAME DAMAGES AND RELIEF AS A COURT (INCLUDING INJUNCTIVE AND DECLARATORY RELIEF OR
                                    STATUTORY DAMAGES) AND MUST FOLLOW THESE TERMS AS A COURT WOULD.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >f.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >PAYMENT OF FILING, ADMINISTRATION AND ARBITRATOR FEES WILL BE GOVERNED BY THE AAA'S COMMERCIAL ARBITRATION RULES. THESE
                                    FEES WILL BE SHARED AS FOLLOWS: ONE THIRD BY YOU AND TWO THIRDS BY US, UNLESS THE ARBITRATOR: (I) DETERMINES THAT THE CLAIMS
                                    ARE FRIVOLOUS, IN WHICH CASE THE CLAIMANT SHALL BEAR ALL SUCH FEES ARISING FROM THE FRIVOLOUS CLAIM; OR (II) DETERMINES THAT
                                    THE FEES SHOULD BE ALLOCATED DIFFERENTLY.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >g.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >YOU AND THE COMPANY HEREBY ACKNOWLEDGE, AGREE AND COVENANT THAT ANY DISPUTES SHALL ONLY BE ADJUDICATED IN ARBITRATION ON AN
                                    INDIVIDUAL BASIS, AND NOT IN CLASS, COLLECTIVE, CONSOLIDATED OR REPRESENTATIVE PROCEEDINGS.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >h.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >YOU MAY OPT-OUT OF THE ABOVE ARBITRATION CLAUSE BY EMAILING US TO SUPPORT@WILLYOU.NET, WITHIN 21 DAYS OF YOU ENTERING INTO
                                    THESE TERMS FOR THE FIRST TIME, AN OPT-OUT NOTICE THAT IDENTIFIES YOURSELF AND CLEARLY SETS OUT YOUR CHOICE TO OPT OUT OF
                                    DISPUTE RESOLUTION BY ARBITRATION. IN CASE OF SUCH OPT-OUT, ANY AND ALL DISPUTES, CLAIMS OR CONTROVERSIES BETWEEN YOU AND US
                                    REGARDING THESE TERMS OR THE USE OF THE SERVICE, WHICH ARE NOT AMICABLY RESOLVED, SHALL BE SUBJECT TO THE EXCLUSIVE
                                    JURISDICTION AND VENUE OF THE STATE AND FEDERAL COURTS IN NEW YORK COUNTY IN THE STATE OF NEW YORK, USA.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpFirst"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level2 lfo14;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-fareast-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    ><span style="mso-list: Ignore"
                                        >i.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span
                                    ></span
                                ><span dir="LTR"></span
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >NOTWITHSTANDING ANYTHING TO THE CONTRARY IN THIS SECTION, EITHER PARTY MAY FILE: (A) AN IMPLEADER CLAIM AGAINST THE OTHER
                                    PARTY IN ANY COURT OF COMPETENT JURISDICTION ADJUDICATING A THIRD PARTY CLAIM THAT IS SUBJECT TO THE INDEMNIFICATION
                                    PROVISIONS OF THIS AGREEMENT; (B) IN ANY COURT OF COMPETENT JURISDICTION A CLAIM CONCERNING THE INFRINGEMENT (OR ALLEGED
                                    INFRINGEMENT) OF INTELLECTUAL PROPERTY RIGHTS (INCLUDING COPYRIGHTS AND TRADE SECRETS).</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-top: 0in;
                                    margin-right: 0in;
                                    margin-bottom: 0in;
                                    margin-left: 1in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        ><span style="mso-list: Ignore">15.<span style="font: 7pt 'Times New Roman'">&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Assignment.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >You may not assign this Agreement without our prior written consent. Any purported assignment without our prior written
                                    consent is void. To the greatest extent permissible by law, we may freely assign this Agreement in its entirety, including
                                    all right, duties, liabilities, performances and obligations herein, including in connection with a merger, acquisition,
                                    change of control or the sale of all or substantially all of our equity or assets. By virtue of such assignment, the
                                    assignee assumes our stead, including all right, duties, liabilities, performances and obligations hereunder, and we are
                                    released therefrom. Any assignments in violation of this Section shall be null and void.<b
                                        ><span style="letter-spacing: 0.3pt"></span></b
                                ></span>
                            </p>

                            <p
                                class="MsoListParagraphCxSpMiddle"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    line-height: normal;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >&nbsp;</span
                                    ></b
                                >
                            </p>

                            <p
                                class="MsoListParagraphCxSpLast"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        ><span style="mso-list: Ignore">16.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Relationship of the Parties.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >The relationship between the parties hereto is strictly that of independent contractors, and neither party is an agent,
                                    partner, joint <span class="SpellE">venturer</span> or employee of the other.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        ><span style="mso-list: Ignore">17.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Subcontracting.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We may subcontract or delegate the performance of our obligations under this Agreement, or the provision of the Service or
                                    Platform (or any part thereof), to any third party of our choosing,&nbsp;provided&nbsp;however, that we remain liable to you
                                    for the performance of our obligations under this Agreement. You acknowledge and agree that the technical means by which we
                                    provide the Service and Platform is at our sole discretion.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        ><span style="mso-list: Ignore">18.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Complete Agreement and Severability.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >This Agreement constitutes the entire and complete agreement between you and us concerning the subject matter herein. This
                                    Agreement supersedes all prior oral or written statements, understandings, negotiations and representations with respect to
                                    the subject matter herein. If any provision of this Agreement is held invalid or unenforceable, that provision shall be
                                    construed in a manner consistent with the applicable law to reflect, as nearly as possible, the original intentions of the
                                    parties, and the remaining provisions will remain in full force and effect.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        ><span style="mso-list: Ignore">19.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >No waiver.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >Neither party will, by mere lapse of time, without giving express notice thereof, be deemed to have waived any breach, by
                                    the other party, of any terms or provisions of this Agreement. The waiver, by either party, of any such breach, will not be
                                    construed as a waiver of subsequent breaches or as a continuing waiver of such breach.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        ><span style="mso-list: Ignore">20.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Force majeure.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >The Company will not be liable for any delay or failure to perform any obligations under this Agreement due to any cause
                                    beyond the Company’s reasonable control, including acts of God, labor disputes or other industrial disturbances, systemic
                                    electrical, telecommunications or other utility failures, earthquakes, storms or other elements of nature, blockages,
                                    embargoes, riots, acts or orders of government, acts of terrorism or war.</span
                                >
                            </p>

                            <p
                                class="MsoNormal"
                                style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal; background: white">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >&nbsp;</span
                                >
                            </p>

                            <p
                                class="MsoListParagraph"
                                style="
                                    margin-bottom: 0in;
                                    margin-bottom: 0.0001pt;
                                    mso-add-space: auto;
                                    text-align: justify;
                                    text-indent: -0.25in;
                                    line-height: normal;
                                    mso-list: l3 level1 lfo14;
                                    background: white;
                                ">
                                <b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-fareast-theme-font: major-bidi;
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                        "
                                        ><span style="mso-list: Ignore">21.<span style="font: 7pt 'Times New Roman'">&nbsp;&nbsp; </span></span></span
                                    ></b
                                ><span dir="LTR"></span
                                ><b
                                    ><span
                                        style="
                                            font-family: 'Times New Roman', serif;
                                            mso-ascii-theme-font: major-bidi;
                                            mso-fareast-font-family: 'Times New Roman';
                                            mso-hansi-theme-font: major-bidi;
                                            mso-bidi-theme-font: major-bidi;
                                            color: #404040;
                                            letter-spacing: 0.3pt;
                                        "
                                        >Modifications.
                                    </span></b
                                ><span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-fareast-font-family: 'Times New Roman';
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                        color: #404040;
                                    "
                                    >We reserve the right, at our sole discretion, to change or modify portions of these Terms of Service at any time. If we do
                                    this, we will post the changes on this page and will indicate at the top of this page the date these Terms of Service were
                                    last revised. We will also notify you of any material changes, either through the Dashboard, in an email notification or
                                    through other reasonable means. Any such changes will become effective no earlier than fourteen (14) days after they are
                                    posted. Your continued use of the Service and Platform after the date any such changes become effective constitutes your
                                    acceptance of the new Terms of Service.</span
                                >
                            </p>

                            <p class="MsoNormal" style="margin-bottom: 0in; margin-bottom: 0.0001pt; text-align: justify; line-height: normal">
                                <span
                                    style="
                                        font-family: 'Times New Roman', serif;
                                        mso-ascii-theme-font: major-bidi;
                                        mso-hansi-theme-font: major-bidi;
                                        mso-bidi-theme-font: major-bidi;
                                    "
                                    >&nbsp;</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "terms-popup",
};
</script>

<style lang="scss">
#terms-popup {
    .modal-body {
        overflow: auto;
        padding-right: 80px;
        padding-left: 80px;
        max-height: 420px;
        -webkit-overflow-scrolling: touch;
    }
    .popup-header {
        border: none;
    }
    .popup-title {
        font-size: 28px;
        color: rgba(0, 0, 0, 0.87);
        font-family: "Noto Serif SC", serif;
    }
    .popup-subtitle {
        font-family: "Noto Serif SC", serif;
        color: rgba(0, 0, 0, 0.87);
        font-size: 14px;
        max-width: 300px;
    }
    @media (min-width: 768px) {
        .modal-dialog {
            max-width: 750px;
        }
    }
    @media (max-width: 767px) {
        .modal-body {
            padding-right: 40px;
            padding-left: 40px;
        }
    }
}
</style>
